import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PoModule, PoWidgetModule } from '@po-ui/ng-components';
import { CommonModule } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';

interface salesOrder {
  branchCode: string;
  fantasyName: string | null;
  personName: string;
  orderCode: string;
  billingForecastDate: string | null;
  statusOrder: string;
  stageOrder: string;
  quantity: number;
  grossValue: number;
  discountValue: number;
  freightValue: number;
  totalValue: number;
  salesOrderItens: salesOrderItens[];
  expanded?: boolean;
}

interface salesOrderItens {
  productCode: string;
  productName: string;
  referenceCode: string;
  quantity: number;
  settledQuantity: number;
  price: number;
  discountValue: number;
  totalValue: number;
}

@Component({
  standalone: true,
  selector: 'app-card',
  imports: [PoWidgetModule, CommonModule, PoModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
  @Input() myData: salesOrder[] | undefined;
  @Input() myDataItens: salesOrderItens[] | undefined;
  @Output() carregarItensPedido = new EventEmitter<{ item: salesOrder }>();
  @Output() downloadPDF = new EventEmitter<{ item: salesOrder }>();

  constructor(
  ) {
    registerLocaleData(ptBr, 'pt-BR');
  }

  ngOnInit() {
  }

  seeDescriptionItens(item: any) {
    item.expanded = !item.expanded;
    if (item.expanded && (!item.salesOrderItens || item.salesOrderItens.length === 0)) {
      this.carregarItensPedido.emit({ item });
    }
  }

  downloadPDFCard(item: any ) {
    this.downloadPDF.emit({ item });
  }

  getStatusClass(status: string): string {
    if (!status) return 'status-blocked';

    const statusMap: any = {
      'Em andamento': 'status-inprogress',
      'Liberado para faturamento': 'status-billingreleased',
      'Parcialmente atendido': 'status-partially',
      'Atendido': 'status-attended',
      'Bloqueado': 'status-blocked',
      'Cancelado': 'status-canceled',
      'Em composição': 'status-composition',
      'Em análise': 'status-analysis'
    };

    return statusMap[status] || 'status-blocked';
  }
  
}
